import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    TextField
} from '@material-ui/core'
import React, {useRef} from 'react'
import {useDispatch} from 'react-redux'
import {useReceivedItemDataGridContext} from './ReceivedDetailsItemDataGrid'
import {updateReceivingItem} from "../../redux/slices/receiving";
import useCallbackGuard from "../../hooks/useCallbackGuard";
import {toast} from "react-toastify";

const UpdateReceivingItem = ({updateOpen, closeUpdateReceiving, updateItem}) => {

    const nameRef = useRef()
    const bcodeRef = useRef()
    const qtyRef = useRef()
    const priceRef = useRef()
    const sellPriceRef = useRef()
    const internalRef = useRef()
    const item = updateItem[0]

    const [isLoading, setLoading] = React.useState(false)

    const dispatch = useDispatch()
    const {callbackGuard} = useCallbackGuard()
    const {receivingId, closeDetail} = useReceivedItemDataGridContext()

    const handleSubmit = () => {

        setLoading(true)

        const receivedItem = {
            ItemId: item.ItemId,
            ExpirationDate: item.ExpirationDate,
            ItemName: nameRef.current.value,
            ItemBarcode: bcodeRef.current.value,
            InternalId: internalRef.current.value ,
            Quantity: parseInt(qtyRef.current.value),
            SellPrice: parseInt(sellPriceRef.current.value),
            Price: parseFloat(priceRef.current.value),
            ItemImageUrl: item.ItemImageUrl,
        }

        // console.group()
        // console.log(receivingId)
        // console.log(item)
        // console.log(receivedItem)
        // console.groupEnd()

        dispatch(updateReceivingItem(receivingId, receivedItem, () => {
            closeUpdateReceiving()
            closeDetail();
            toast.success('Mise a jour reussie')
            callbackGuard(() => setLoading(false))
        }))

        // try {
        //     actionDispatch(UpdateReceivingItemAction({
        //         receivingId: receivingId,
        //         Receiving: receivedItem,
        //         callback: () => {
        //             closeUpdateReceiving()
        //             closeDetail()
        //         }
        //     }))
        //
        // } catch (error) {
        //     setLoading(false)
        // } finally {
        //     setLoading(false)
        // }

    }


    return (
        <Dialog open={updateOpen} onClose={closeUpdateReceiving}>
            <form onSubmit={(e) => {
                e.preventDefault()
                handleSubmit()
            }}>
                <DialogTitle> {"Mise à jour"} </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>

                        <Grid item xs={12} sm={12}>
                            <TextField margin="dense" variant="outlined"
                                       fullWidth defaultValue={item.ItemName}
                                       inputRef={nameRef}
                                       label="Nom du produit"/>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField margin="dense" variant="outlined"
                                       fullWidth defaultValue={item.ItemBarcode}
                                       inputRef={bcodeRef}
                                       label="Code Bare"/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField margin="dense" variant="outlined" fullWidth
                                       defaultValue={item.InternalId}
                                       inputRef={internalRef}
                                       label="Code Prosoft"/>
                        </Grid>

                        <Grid item xs={12} sm={6}>
                            <TextField margin="dense" variant="outlined" type="number"
                                       inputRef={qtyRef}
                                       label="Quantité" fullWidth defaultValue={item.Quantity}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField margin="dense" variant="outlined"
                                       type="number" inputRef={priceRef}
                                       label="Prix d'achat" fullWidth defaultValue={item.Price}/>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextField margin="dense" variant="outlined" type="number"
                                       inputRef={sellPriceRef}
                                       label="Prix de vente" fullWidth defaultValue={item.SellPrice}/>
                        </Grid>

                    </Grid>
                </DialogContent>

                <DialogActions>
                    <Grid container justify="space-between">
                        <Button onClick={closeUpdateReceiving} size="small" variant="contained"
                                color="secondary">annuler</Button>

                        <Button size="small" variant="contained" color="primary"
                                type="submit" disabled={isLoading}>
                            {isLoading ? <CircularProgress size={15}/> : "Editer"}
                        </Button>
                    </Grid>
                </DialogActions>
            </form>
        </Dialog>
    )

}

export default UpdateReceivingItem
